<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              <router-link :to="{ name: 'configuracion-carta' }">
                {{ $t("configuracionCarta") }}</router-link
              >
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("personalizacion") }}
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-5">
              <div class="form-group">
                <label for="listBusiness"
                  ><strong>{{ $t("negocio") }}</strong></label
                >

                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  @change="permisoCarta()"
                  :placeholder="this.$i18n.t('seleccionaNegocio')"
                >
                  <el-option
                    v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template v-if="permiso === 1"> </template>
      <template v-else-if="permiso && respuesta">
        <div class="col-md-12">
          <div class="card">
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-12">
                    <h5 class="tituloPedido">
                      {{ $t("opcionesConfiguracion") }}
                    </h5>
                    <hr />
                  </div>

                  <div class="col-md-6"  v-tooltip.right="$t('tolTipImagenCarga')">
                    <div class="form-group">
                      <label for="nombre-mostrado"
                        ><strong>{{ $t("imagenCargando") }}</strong></label
                      >
                    </div>
                    <b-form-select
                      variant="primary"
                      style="float: left;"
                      v-model="personalizaciones.lottie"
                      :options="options"
                      class=" col-md-12"
                      value-field="item"
                      text-field="name"
                      disabled-field="notEnabled"
                    ></b-form-select>
                  </div>

                  <div class="col-md-6">
                    <div style="margin-top:12%">
              
                      <button @click="cargarLoading()" class="btn btn-primary">
                        <i class="far fa-eye fa-lg"></i> {{ $t("vistaPrevia") }}
                      </button >
       
                     
                    </div>
                  </div>
                  <div class="col-md-6"> 
                    <img id="gif" src="" style="width:200px;heigth:200px;display:block;margin:auto;margin-top:0%"/>
                  </div>
                   
                </div>
              </div>

              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-12">
                    <h5 class="tituloPedido">{{ $t("textos") }}</h5>
                    <hr />
                  </div>

                  <div class="col-md-12" v-tooltip.left="$t('tolTipTituloDestacado')">
                    <div class="form-group">
                      <label for="tiempo-preparacion-recogida"
                        ><strong>{{ $t("destacadosTitulo") }}</strong></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="tituloActual"
                        v-model="personalizaciones.tituloDestacados"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12 text-right">
                <button
                  @click="preguntarConfirmacion()"
                  class="btn btn-primary"
                >
                  <i class="fa fa-check-square"></i> {{ $t("guardar") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="!permiso">
        <div class="col-md-12">
          <div class=" alert alert-primary" align="center">
            <h3>
              <i class="fas fa-exclamation-circle"></i>
              {{ $t("esteNegocioNoTieneAccesoAEsteModulo") }}.
            </h3>

            <span>
              {{ $t("paraMasInformacionContacteConSu") }}
              <strong>{{ $t("distribuidor") }}</strong
              >.</span
            >
          </div>
        </div>
      </template>
 
    </div>
  </div>
</template>

<script>
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Switch,
  Checkbox,
} from "element-ui";
import { Loading } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
export default {
  name: "ConfiguracionNegocio",
  data() {
    return {
      personalizaciones: {
        lottie: "",
        tituloDestacados: "",
      },
      listOperarios: [],
      listAgencias: [],
      listBusinesses: [],
      idBusiness: 0,
      permiso: 1,
      respuesta: false,
      configuracionCarta: {
        nombreMostrado: "",
        email: "",
        telefono: "",
        telefonoWhatapp: "",
        descripcion: "",
        tiempoMedio: "",
        takeawaytime: 0,
        gastoEnvio: "",
        pedidoMinimo: "",
        emailCliente: false,
        textoEntrega: "",
        textoPresentacion: "",
        textoFormasPago: "",
        direccion: "",
      },

      loading: null,
      options: [
        { item: "", name: "Por defecto" },
        { item: "ha", name: "Hamburguesa" },
        { item: "pi", name: "Pizza" },
        { item: "wo", name: "Sartén Wok" },
        { item: "bu", name: "Burrito" },
        { item: "co", name: "Cocktail" },
        { item: "ho", name: "Perrito Caliente" },
        { item: "pa", name: "Patatas Fritas" },
        { item: "po", name: "Pollo Frito" },
        { item: "mo", name: "Mojito" },
        { item: "ra", name: "Ramen" },
        // { item: "do", name: "Donuts" },
        { item: "he", name: "Helado" },


      ],

    };
  },
  created() {
    this.getBusiness();

    this.$store.dispatch("setNameRoute", "Configuración negocio");

    this.getConfigTpv();
  },
  methods: {
    guardarTituloDestacado() {
      const tituloNuevo = this.personalizaciones.tituloDestacados;

      //Peticion para modificar el nuevo titulo.
      this.loading = Loading.service({ text: "Cargando..." });
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusinessInfo: this.idCarta,
        numConfig: 64,
        valor: tituloNuevo,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      this.axios
        .post(
          this.$store.getters.apiUrl + "general/setConfigBusinessInfo",
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.$modal.hide("tituloDestacados");
            vm.$notify({
              message: "Titulo editado " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          }
        })
        .catch(function(error) {
          swal({
            title: vm.$t("atencion"),
            text: response.data.message,
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
          console.log(error);
        })
        .finally((_) => {
          vm.loading.close();
        });
    },
    permisoCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          estado: this.estado,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getPermisoCarta", config)
        .then(function(response) {
          if (response.data.response) {
            if (response.data.result) {
              vm.respuesta = true;

              vm.permiso = response.data.result.permiso;

              vm.listCartas = response.data.result.listCartas;
              if (response.data.result.permiso) {
                response.data.result.listCartas.forEach(function(x) {
                  if (x.tokenServerSinqro) {
                    vm.tokenServerSinqro = x.tokenServerSinqro;
                  }

                  if (x.tokenUserSinqro) {
                    vm.tokenUserSinqro = x.tokenUserSinqro;
                  }

                  if (x.tiene_sinqro) {
                    if (x.tiene_sinqro == "1") {
                      vm.tieneSinqro = true;
                    } else {
                      vm.tieneSinqro = false;
                    }
                  }

                  if (x.noRecoger == true) {
                    vm.noRecoger = "1";
                  } else {
                    vm.noRecoger = "0";
                  }

                  if (x.noDomicilio == true) {
                    vm.noDomicilio = "1";
                  } else {
                    vm.noDomicilio = "0";
                  }

                  if (x.multiCartaSinqro == true) {
                    vm.multiCartaSinqro = true;
                  } else {
                    vm.multiCartaSinqro = false;
                  }
                  let encontrado = false;
                  x.config.forEach((element) => {
                    if (element.nombre == "tituloDestacados") {
                      vm.personalizaciones.tituloDestacados = element.valor;
                      encontrado = true;
                    }
                  });

                  if (!encontrado) {
                    vm.personalizaciones.tituloDestacados =
                      "Productos destacados";
                  }
                });
                vm.idCarta = response.data.result.listCartas[0].id;
              }

              if (response.data.result.permiso) {
                vm.getConfiguracionCarta();
                vm.getConfigTpv();
              }
            } else {
              vm.respuesta = false;

              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.listBusinesses = response.data.result;

          vm.permisoCarta();
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    camposVacios() {
      const form = this.personalizaciones;
      let vacio = false;
      if (form.tituloDestacados == "") {
        vacio = true;
      }
      if (form.lottie == null) {
        vacio = true;
      }
      return vacio;
    },
    preguntarConfirmacion() {
      if (this.camposVacios()) {
        swal({
          title: "Hay datos del negocio en blanco",
          text: "¿Estás seguro de que deseas guardar cambios?",
          icon: "warning",
          buttons: true,
          dangerMode: true,
          showCancelButton: true,
          confirmButtonClass: "btn btn-info btn-fill",
          confirmButtonText: "Estoy seguro",
          cancelButtonText: "Cancelar",
        }).then((seguro) => {
          if (seguro.value == true) {
            this.crearListaConfigs();
          }
        });
      } else {
        this.crearListaConfigs();
      }
    },
    crearListaConfigs() {
      let configList = [];
      //De momento el idConfig, esta escrito a mano.
      let newConfigTpv = {
        idBusinessInfo: this.idCarta,
        numConfig: 63,
        valor: this.personalizaciones.lottie,
        jwt: this.$store.getters.jwt,
      };
      configList.push({ ...newConfigTpv });

      newConfigTpv.numConfig = 64;
      newConfigTpv.valor = this.personalizaciones.tituloDestacados.replaceAll(
        '"',
        ""
      );
      newConfigTpv.valor = this.personalizaciones.tituloDestacados.replaceAll(
        "'",
        ""
      );

      newConfigTpv.valor = this.personalizaciones.tituloDestacados.replaceAll(
        "\\",
        "/"
      );

      configList.push({ ...newConfigTpv });

      this.guardarConfiguraciones(configList);
    },
    guardarConfiguraciones(configList) {
      this.loading = Loading.service({ text: "Cargando..." });

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      let vm = this;

      configList.forEach((element) => {
        var params = element;
        this.axios
          .post(
            this.$store.getters.apiUrl + "general/setConfigBusinessInfo",
            params,
            config
          )
          .then(function(response) {
            if (response.data.response && configList.at(-1) == element) {
              vm.$notify({
                message: "Configuración guardada " + vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
            }
          })
          .catch(function(error) {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
            console.log(error);
          })
          .finally((_) => {
            vm.loading.close();
          });
      });
    },

    getConfigTpv() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          numConfig: 61,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
        .then(function(response) {
          if (response.data.response) {
            vm.configuracionCarta.emailCliente = true;
          } else {
            vm.configuracionCarta.emailCliente = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    getConfiguracionCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      this.$store.dispatch("setIdBusiness", this.idBusiness);

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "delivery/getConfiguracionCarta",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            if (response.data.result) {
              vm.respuesta = true;
              vm.configuracionCarta = response.data.result;

              //NUEVO
              if (response.data.result.lottie == null) {
                vm.personalizaciones.lottie = "";
              } else {
                vm.personalizaciones.lottie = response.data.result.lottie;
              }
            }
          } else {
            vm.respuesta = false;
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        });
    },
//aqui se cargan los gif
    cargarLoading() {
      switch (this.personalizaciones.lottie) {

        case "ha":  
          document.getElementById('gif').src=require('@/assets/burguer-color.gif');
         
          break;
           case "bu":  
          document.getElementById('gif').src=require('@/assets/burrito.gif');
         
          break;
             break;
           case "co":  
          document.getElementById('gif').src=require('@/assets/cocktail.gif');
         
          break;
            case "ho":  
          document.getElementById('gif').src=require('@/assets/hot-dog.gif');
         
          break;
             case "pa":  
          document.getElementById('gif').src=require('@/assets/patatas-fritas.gif');
         
          break;
              case "po":  
          document.getElementById('gif').src=require('@/assets/pollo-frito.gif');
         
          break;
               case "mo":  
          document.getElementById('gif').src=require('@/assets/mojito.gif');
         
          break;
                case "ra":  
          document.getElementById('gif').src=require('@/assets/ramen.gif');
         
          break;
                 case "do":  
          document.getElementById('gif').src=require('@/assets/donuts.gif');
         
          break;
              case "he":  
          document.getElementById('gif').src=require('@/assets/helado.gif');
         
          break;

        case "pi":
          document.getElementById('gif').src=require('@/assets/pizza.gif');
          break;

          case "wo":

           document.getElementById('gif').src=require('@/assets/wok.gif');
          break;

        default:
          document.getElementById('gif').src=require('@/assets/plato.gif');
          break;
      }

      setTimeout(() => {
        document.getElementById('gif').src=require('@/assets/placeholder.png');
        document.getElementById('gif').style.width="200px";
        document.getElementById('gif').style.height="200px";
        document.getElementById('gif').style.display="block";
        document.getElementById('gif').style.margin="auto";

      }, 3000);

    },
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Switch.name]: Switch,
    [Checkbox.name]: Checkbox,
 
  },
};
</script>
<style>
/* Estilos para las distintas pantallas de carga  */
/* UPDATE Los estilos de lottie ya no valen, se llaman los gifs directamente desde la ruta de la carpeta */
.el-loading-mask.lottieLoader {
  background-image: url('~@/assets/img/plato.gif');
  color: black;
  background-size: 25%;
  background-position: center;
  background-position-y: 5%;
  background-repeat: no-repeat;

  animation: fade ease 2s;
  animation-fill-mode: forwards;
}

.el-loading-mask.lottieLoaderBu {
  background-image: url('~@/assets/img/burguer-color.gif');
  color: black;
  background-size: 20%;
  background-position: center;
  background-position-y: 20%;
  background-repeat: no-repeat;

  animation: fade ease 2s;
  animation-fill-mode: forwards;
}

.el-loading-mask.lottieLoaderPi {
  background-image: url('~@/assets/img/pizza.gif');
  color: black;
  background-size: 20%;
  background-position: center;
  background-position-y: 20%;
  background-repeat: no-repeat;

  animation: fade ease 2s;
  animation-fill-mode: forwards;
}

.el-loading-mask.lottieLoaderWo {
  background-image: url('~@/assets/img/wok.gif');
  color: black;
  background-size: 20%;
  background-position: center;
  background-position-y: 20%;
  background-repeat: no-repeat;

  animation: fade ease 2s;
  animation-fill-mode: forwards;
}

.el-loading-mask.lottieLoaderCo {
  background-image: url('~@/assets/cocktail.gif');
  color: black;
  background-size: 20%;
  background-position: center;
  background-position-y: 20%;
  background-repeat: no-repeat;

  animation: fade ease 2s;
  animation-fill-mode: forwards;
}
.el-loading-mask.lottieLoaderDo {
  background-image: url('~@/assets/donuts.gif');
  color: black;
  background-size: 20%;
  background-position: center;
  background-position-y: 20%;
  background-repeat: no-repeat;

  animation: fade ease 2s;
  animation-fill-mode: forwards;
}
.el-loading-mask.lottieLoaderHe {
  background-image: url('~@/assets/helado.gif');
  color: black;
  background-size: 20%;
  background-position: center;
  background-position-y: 20%;
  background-repeat: no-repeat;

  animation: fade ease 2s;
  animation-fill-mode: forwards;
}
.el-loading-mask.lottieLoaderDo {
  background-image: url('~@/assets/hot-dog.gif');
  color: black;
  background-size: 20%;
  background-position: center;
  background-position-y: 20%;
  background-repeat: no-repeat;

  animation: fade ease 2s;
  animation-fill-mode: forwards;
}
.el-loading-mask.lottieLoaderMo {
  background-image: url('~@/assets/mojito.gif');
  color: black;
  background-size: 20%;
  background-position: center;
  background-position-y: 20%;
  background-repeat: no-repeat;

  animation: fade ease 2s;
  animation-fill-mode: forwards;
}
.el-loading-mask.lottieLoaderPa {
  background-image: url('~@/assets/patatas-fritas.gif');
  color: black;
  background-size: 20%;
  background-position: center;
  background-position-y: 20%;
  background-repeat: no-repeat;

  animation: fade ease 2s;
  animation-fill-mode: forwards;
}
.el-loading-mask.lottieLoaderPo {
  background-image: url('~@/assets/pollo-frito.gif');
  color: black;
  background-size: 20%;
  background-position: center;
  background-position-y: 20%;
  background-repeat: no-repeat;
  animation: fade ease 2s;
  animation-fill-mode: forwards;
}
.el-loading-mask.lottieLoaderRa {
  background-image: url('~@/assets/ramen.gif');
  color: black;
  background-size: 20%;
  background-position: center;
  background-position-y: 20%;
  background-repeat: no-repeat;
  animation: fade ease 2s;
  animation-fill-mode: forwards;
} 
@keyframes fade {
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
<style scoped>
tbody tr:hover {
  background-color: rgba(0, 153, 130, 0.2);
  cursor: pointer;
}

td div {
  padding: 12px 8px;
  color: #333;
}

.buttonsSearch:hover {
  cursor: pointer;
  background-color: rgba(0, 153, 130, 0.1);
}

.card {
  padding: 20px;
}

.input-group button {
  height: 40px;
}

.botonTotal {
  border: 1px solid #28a745;
  color: #ffffff;
  background-color: #28a745;
  font-weight: 400;
  padding: 8px 16px;
  /* cursor: pointer; */
  margin-bottom: 5px;
  font-size: 14px;
  line-height: 1.42857143;
}

.nombreProducto {
  color: #fff;
  background-color: #0e0e0e;
  text-shadow: 1px 1px #333;
  font-weight: 700;
  font-size: 15px;
}

.tituloPedido {
  color: #1E22AA;
  font-family: "Numier", "Helvetica Neue", Arial;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/Personalizacion/PersonalizarCarta.vue